<template>
  <v-card class="mx-auto" max-width="344" hover>
    <v-img :src="foto" height="200px" cover></v-img>

    <h5 style="padding: 20px; font-size: larger; font-weight: 700">
      {{ title }}
    </h5>

    <v-card-subtitle> {{ subtitle }} </v-card-subtitle>

    <v-card-actions>
      <v-btn v-if="ExtraInfo" color="orange-lighten-2" variant="text">
        Mas Info

        <v-dialog v-model="dialog" activator="parent" width="auto">
          <v-card>
            <v-card-text align="center">
              <h4
                style="
                  color: #1866c0;
                  font-weight: 600;
                  font-family: Arial, Helvetica, sans-serif;
                "
              >
                Documentos requeridos para tramite
              </h4>
              <divider-component></divider-component>

              <ul class="lista-centrada">
                <li>Constancia de Situación Fiscal</li>
                <li>INE Vigente</li>
                <li>Numero Telefónico</li>
                <li>Copia de tarjeta de MEJORAVIT</li>
              </ul>
              <v-divider></v-divider>
              <h5
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  font-weight: 600;
                  color: #1866c0;
                "
              >
                Mejoravit Repara
              </h5>
              <p class="txtdata">
                Orientado a reparaciones menores que no afecten la estructura
                principal de la vivienda. El monto del crédito oscila entre
                $9,461.09 y $37,844.35 pesos, con una tasa de interés anual fija
                del 10%. Los plazos de pago pueden variar de uno a cinco años.
              </p>

              <h5
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  font-weight: 600;
                  color: #1866c0;
                "
              >
                Mejoravit Renueva
              </h5>
              <p class="txtdata">
                Diseñado para renovaciones más significativas, el monto del
                crédito varía entre $37,844.35 y $149,485.19 pesos, con una tasa
                de interés anual fija del 11%. El plazo de pago puede extenderse
                de uno a diez años.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" block @click="dialog = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>

      <v-btn v-else color="orange-lighten-2" variant="text" :to="'/' + Ruta"
        >Catálogo</v-btn
      >

      <v-spacer></v-spacer>

      <v-btn
        :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        @click="show = !show"
      ></v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text
          style="
            font-size: medium;
            font-family: Arial, Helvetica, sans-serif;
            font-weight: 400;
          "
        >
          {{ description }}
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import DividerComponent from './DividerComponent.vue';
export default {
  components: { DividerComponent },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    foto: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    ExtraInfo: {
      type: Boolean,
      default: false,
    },
    Ruta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      dialog: false,
    };
  },
};
</script>

<style scoped>
.txtdata {
  font-family: Arial, Helvetica, sans-serif;
}
.lista-centrada {
  list-style: none; /* Remueve los puntos por defecto */
  padding: 0; /* Remueve el padding por defecto */
  text-align: center; /* Centra el texto de los elementos de la lista */
}
.lista-centrada li::before {
  content: '✅'; /* Añade un punto como marcador */
  display: inline-block; /* Hace que el marcador sea parte del flujo de texto */
  width: 25px; /* Espacio antes del texto */
  margin-left: -1em; /* Alinea el marcador con el texto */
}
</style>
